import { Box } from '@mui/material'
import { FC } from 'react'

const COLOR = '#9CA3AF'

export interface FlowArrowProps {
  /** Length in px. */
  width?: number
  /** Top margin in theme spacing units, to line the arrow up with what it joins. */
  mt?: number
}

/** A thin grey left-to-right arrow: what follows next in time. */
export const FlowArrow: FC<FlowArrowProps> = ({ width = 24, mt = 0 }) => (
  <Box
    component="svg"
    width={width}
    height={8}
    viewBox={`0 0 ${String(width)} 8`}
    aria-hidden
    data-testid="flow-arrow"
    sx={{ flexShrink: 0, mt }}
  >
    <line x1={0} y1={4} x2={width - 2} y2={4} stroke={COLOR} strokeWidth={1} />
    <path d={`M${String(width - 6)} 1 L${String(width - 1)} 4 L${String(width - 6)} 7`} fill="none" stroke={COLOR} strokeWidth={1} />
  </Box>
)
